import { render, staticRenderFns } from "./page-workOrder-info.vue?vue&type=template&id=686748c8&scoped=true&"
import script from "./page-workOrder-info.vue?vue&type=script&lang=js&"
export * from "./page-workOrder-info.vue?vue&type=script&lang=js&"
import style0 from "./page-workOrder-info.vue?vue&type=style&index=0&id=686748c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686748c8",
  null
  
)

component.options.__file = "page-workOrder-info.vue"
export default component.exports